export function Badge({ badge }) {
  if (!badge) return null
  return (
    <p
      style={`--bg-color:${badge.backgroundColor?.value};--fg-color:${badge.foregroundColor?.value}`}
      className="paragraph-sm w-fit -rotate-1 whitespace-nowrap bg-[--bg-color] px-2 py-1 font-bold text-[--fg-color] sm:group-hover/card:animate-wiggle"
    >
      {badge.text}
    </p>
  )
}
